import * as React from 'react';
import DashboardLayout from '../layout/DashboardLayout';
import { SerializedStyles } from '@emotion/core';
import ReportRecipientMenu from './ReportRecipientMenu';


type Props = {
  children: React.ReactNode;
  floatMenu?: boolean;
  className?: string;
  contentStyle?: SerializedStyles;
};


/**
 * ReportRecipientLayout: a component that renders the root layout of report recipient pages with the side menu
 * containing recipient area links and the main content area.
 *
 * PureComponent: true
 * Redux Connected: false
 */
const ReportRecipientLayout: React.FC<Props> = props => (
  <DashboardLayout {...props} menu={<ReportRecipientMenu />}>
    {props.children}
  </DashboardLayout>
);

export default ReportRecipientLayout;
